<template>
  <div class="d-flex flex-column flex-root" v-if="isAuthenticated">
    <!-- begin:: Header Mobile -->
    <KTHeaderMobile></KTHeaderMobile>
    <!-- end:: Header Mobile -->

    <Loader v-if="loaderEnabled" v-bind:logo="loaderLogo"></Loader>

    <!-- begin::Body -->
    <div class="d-flex flex-row flex-column-fluid page">
      <!-- begin:: Aside Left -->
      <KTAside v-if="asideEnabled"></KTAside>
      <!-- end:: Aside Left -->

      <div
        id="kt_wrapper"
        class="d-flex flex-column flex-row-fluid wrapper"
        v-bind:style="styleWrapper"
      >
        <!-- begin:: Header -->
        <KTHeader v-if="headerDisplay"></KTHeader>
        <!-- end:: Header -->

        <!-- begin:: Content -->
        <div
          id="kt_content"
          class="content d-flex flex-column flex-column-fluid"
          v-bind:style="styleContent"
        >
          <!-- begin:: Content Head -->

          <!-- begin:: Content Head -->
          <KTSubheader
            v-if="subheaderDisplay"
            v-bind:breadcrumbs="breadcrumbs"
            v-bind:title="pageTitle"
          />
          <!-- end:: Content Head -->

          <!-- begin:: Content Body -->
          <div class="d-flex flex-column-fluid">
            <div
              :class="{
                'container-fluid': contentFluid,
                container: !contentFluid
              }"
              v-bind:style="styleContainer"
            >
              <transition name="fade-in-up">
                <router-view />
              </transition>
            </div>
          </div>
        </div>
        <KTFooter v-if="footerDisplay"></KTFooter>
      </div>
    </div>

    <transition name="protecao-flutuante-aparecer">
      <botao-protecao-dados
        v-if="exibirBotaoProtecaoDadosFlutuante"
        :class="[
          'protecao-dados-flutuante',
          {
            'protecao-dados-flutuante--painel-aberto': painelFlutuanteAberto,
            'protecao-dados-flutuante--suporte-visivel': botaoSuporteVisivel
          }
        ]"
        :style="{
          '--protecao-painel-right': `${larguraPainelFlutuante + 24}px`
        }"
        modo-menu
        modo-flutuante
      ></botao-protecao-dados>
    </transition>

    <v-overlay :value="overlay || false" :z-index="99999">
      <v-progress-circular indeterminate size="64" color="#462181"
        ><v-progress-circular
          indeterminate
          size="48"
          color="#ff7f00"
          rotate="180"
        ></v-progress-circular
      ></v-progress-circular>
    </v-overlay>

    <LockOverlay />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import KTAside from "@/view/layout/aside/Aside.vue";
import KTHeader from "@/view/layout/header/Header.vue";
import KTHeaderMobile from "@/view/layout/header/HeaderMobile.vue";
import KTFooter from "@/view/layout/footer/Footer.vue";
import HtmlClass from "@/core/services/htmlclass.service";
import KTSubheader from "@/view/layout/subheader/Subheader.vue";
import Loader from "@/view/content/Loader.vue";
import LockOverlay from "@/view/layout/extras/LockOverlay.vue";
import BotaoProtecaoDados from "@/view/components/BotaoProtecaoDados.vue";
import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME
} from "@/core/services/store/htmlclass.module.js";

export default {
  name: "Layout",
  components: {
    KTAside,
    KTHeader,
    KTHeaderMobile,
    KTFooter,
    KTSubheader,
    Loader,
    LockOverlay,
    BotaoProtecaoDados
  },
  beforeMount() {
    // show page loading
    this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");

    // initialize html element classes
    HtmlClass.init(this.layoutConfig());
  },
  mounted() {
    // Simulate the delay page loading
    setTimeout(() => {
      // Remove page loader after some time
      this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
    }, 2000);

    this.observadorPainelFlutuante = new MutationObserver(() => {
      this.atualizarEstadoBotoesFlutuantes();
    });
    this.observadorPainelFlutuante.observe(document.body, {
      childList: true,
      subtree: true
    });
    this.atualizarEstadoBotoesFlutuantes();
    window.addEventListener("resize", this.atualizarEstadoBotoesFlutuantes);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.atualizarEstadoBotoesFlutuantes);
    if (this.observadorPainelFlutuante) {
      this.observadorPainelFlutuante.disconnect();
    }
    if (this.observadorBotaoSuporte) {
      this.observadorBotaoSuporte.disconnect();
    }
  },
  data() {
    return {
      painelFlutuanteAberto: false,
      larguraPainelFlutuante: 333,
      botaoSuporteVisivel: false,
      observadorPainelFlutuante: null,
      observadorBotaoSuporte: null,
      elementoSuporteObservado: null
    };
  },
  methods: {
    atualizarEstadoBotoesFlutuantes() {
      const painelFlutuante = document.querySelector(
        ".chatbot-container .sidebar-container"
      );
      this.painelFlutuanteAberto = Boolean(painelFlutuante);
      this.larguraPainelFlutuante = painelFlutuante
        ? painelFlutuante.getBoundingClientRect().width
        : 333;

      const botaoSuporte = document.querySelector(".woot-widget-bubble");
      if (botaoSuporte !== this.elementoSuporteObservado) {
        if (this.observadorBotaoSuporte) {
          this.observadorBotaoSuporte.disconnect();
          this.observadorBotaoSuporte = null;
        }
        this.elementoSuporteObservado = botaoSuporte;
        if (botaoSuporte) {
          this.observadorBotaoSuporte = new MutationObserver(() => {
            this.atualizarEstadoBotoesFlutuantes();
          });
          this.observadorBotaoSuporte.observe(botaoSuporte, {
            attributes: true,
            attributeFilter: ["class", "style", "aria-hidden"]
          });
        }
      }
      if (
        botaoSuporte &&
        botaoSuporte.classList.contains("wellon-chatwoot-hover-expand")
      ) {
        this.configurarAnimacaoBolhaSuporte(botaoSuporte);
      }
      if (!botaoSuporte) {
        this.botaoSuporteVisivel = false;
        return;
      }

      const estilo = window.getComputedStyle(botaoSuporte);
      const dimensoes = botaoSuporte.getBoundingClientRect();
      this.botaoSuporteVisivel =
        estilo.display !== "none" &&
        estilo.visibility !== "hidden" &&
        Number(estilo.opacity) !== 0 &&
        dimensoes.width > 0 &&
        dimensoes.height > 0;
    },
    configurarAnimacaoBolhaSuporte(botao) {
      if (botao.dataset.wellonHoverExpandBound === "true") return;

      botao.dataset.wellonHoverExpandBound = "true";
      const duracao = window.matchMedia("(prefers-reduced-motion: reduce)")
        .matches
        ? "0.01ms"
        : "320ms";
      botao.style.setProperty(
        "transition",
        `width ${duracao} cubic-bezier(0.2, 0.8, 0.2, 1)`,
        "important"
      );

      const fechar = () => {
        botao.classList.remove("wellon-chatwoot-hover-expand--aberta");
        botao.style.setProperty("width", "48px", "important");
      };
      const abrir = () => {
        botao.classList.add("wellon-chatwoot-hover-expand--aberta");
        botao.style.setProperty("width", "260px", "important");
      };

      fechar();
      botao.addEventListener("pointerenter", abrir);
      botao.addEventListener("pointerleave", fechar);
      botao.addEventListener("focusin", abrir);
      botao.addEventListener("focusout", (evento) => {
        if (!botao.contains(evento.relatedTarget)) fechar();
      });
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "overlay",
      "currentUserPersonalInfo"
    ]),

    exibirBotaoProtecaoDadosFlutuante() {
      if (this.headerDisplay) return false;
      if (
        ["nps", "mapeamento-perfil", "estatistica"].includes(this.$route.name)
      ) {
        return false;
      }

      if (this.$route.name !== "bi") return true;

      const menus = this.currentUserPersonalInfo.novosMenus || [];
      if (!menus.length) return false;

      const painelExecutivo = menus.find(
        (menu) => menu.titulo?.trim().toLowerCase() === "painel executivo"
      );
      const atendimento = (painelExecutivo?.submenu || []).find(
        (submenu) => submenu.titulo?.trim().toLowerCase() === "atendimento"
      );
      return atendimento?.link?.split(/[?#]/)[0] !== this.$route.path;
    },

    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },

    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return (
        this.$route.name === "dashboard" ||
        this.layoutConfig("content.width") === "fluid"
      );
    },
    styleWrapper() {
      return this.layoutConfig("wrapper");
    },
    styleContent() {
      return this.layoutConfig("styleContetnt");
    },
    styleContainer() {
      return this.layoutConfig("styleContainer");
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },

    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },

    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },
    /**
     * Set the header display
     * @returns {boolean}
     */
    headerDisplay() {
      return !!this.layoutConfig("header.self.display");
    },
    /**
     * Set the footer display
     * @returns {boolean}
     */
    footerDisplay() {
      return !!this.layoutConfig("footer.self.display");
    },
    /**
     * Set the scrollTop display
     * @returns {boolean}
     */
    scrollTopDisplay() {
      return !!this.layoutConfig("scrollTop.self.display");
    }
  }
};
</script>

<style lang="scss">
.protecao-dados-flutuante {
  position: fixed;
  right: 20px;
  bottom: 24px;
  z-index: 2701;
  width: 48px;
  box-sizing: border-box;
  transition: width 0.3s ease-in-out, right 0.35s ease, transform 0.35s ease,
    opacity 0.25s ease;
  > span {
    display: block;
  }
  button.btn {
    width: 100% !important;
    box-sizing: border-box;
    height: 48px;
    padding: 0;
    border: 0 !important;
    border-radius: 120px;
    background: #472282 !important;
    color: #fff !important;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0;
    overflow: hidden;
    white-space: nowrap;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18);
    transition: padding 0.3s ease-in-out, background-color 0.3s ease-in-out;
    i {
      position: static;
      width: 48px !important;
      height: 48px;
      margin: 0 !important;
      padding: 0 !important;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 0 0 48px;
      transform: none;
      color: #fff !important;
      text-align: center;
      font-size: 1.4rem !important;
    }
    > span {
      max-width: 0;
      opacity: 0;
      overflow: hidden;
      font-size: 14px !important;
      transition: max-width 0.3s ease-in-out, opacity 0.2s ease-in-out;
    }
    &:hover,
    &:focus-visible {
      padding-right: 8px;
      justify-content: flex-start;
      > span {
        max-width: 190px;
        opacity: 1;
      }
    }
  }

  &:hover,
  &:focus-within {
    width: 224px;
  }
}

.protecao-dados-flutuante.protecao-dados-flutuante--recolhido {
  width: 48px;

  button.btn {
    padding-right: 0;
    justify-content: center;

    > span {
      max-width: 0;
      opacity: 0;
    }
  }
}

.protecao-dados-flutuante--painel-aberto {
  right: var(--protecao-painel-right, 357px);
}

.protecao-dados-flutuante--suporte-visivel {
  bottom: 90px;
}

.woot-widget-bubble.wellon-chatwoot-hover-expand {
  width: 48px !important;
  min-width: 48px !important;
  max-width: 260px !important;
  height: 48px !important;
  padding: 0 !important;
  position: fixed !important;
  overflow: hidden !important;
  box-sizing: border-box !important;
  border-radius: 999px !important;
  transition: width 0.3s cubic-bezier(0.2, 0.8, 0.2, 1) !important;
}

.woot-widget-bubble.wellon-chatwoot-hover-expand #woot-widget-bubble-icon {
  position: absolute !important;
  top: 8px !important;
  left: 8px !important;
  width: 32px !important;
  height: 32px !important;
  margin: 0 !important;
}

.woot-widget-bubble.wellon-chatwoot-hover-expand #woot-widget--expanded__text {
  position: absolute !important;
  top: 50% !important;
  left: 48px !important;
  right: 14px !important;
  display: block !important;
  width: auto !important;
  max-width: none !important;
  margin: 0 !important;
  overflow: hidden !important;
  opacity: 0 !important;
  font-size: 16px !important;
  white-space: nowrap !important;
  transform: translate(8px, -50%) !important;
  transition: opacity 0.16s ease-in-out, transform 0.3s ease-in-out !important;
}

.woot-widget-bubble.wellon-chatwoot-hover-expand--aberta {
  width: 260px !important;
}

.woot-widget-bubble.wellon-chatwoot-hover-expand--aberta
  #woot-widget--expanded__text {
  opacity: 1 !important;
  transform: translate(0, -50%) !important;
}

.protecao-flutuante-aparecer-enter-active,
.protecao-flutuante-aparecer-leave-active {
  transition: opacity 0.25s ease, transform 0.35s ease;
}

.protecao-flutuante-aparecer-enter,
.protecao-flutuante-aparecer-leave-to {
  opacity: 0;
  transform: translateY(16px);
}

@media (max-width: 575.98px) {
  .protecao-dados-flutuante {
    right: 12px;
    bottom: 12px;
  }
  .protecao-dados-flutuante--painel-aberto {
    right: min(var(--protecao-painel-right, 357px), calc(100vw - 72px));
  }
  .protecao-dados-flutuante--suporte-visivel {
    bottom: 78px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .protecao-dados-flutuante,
  .protecao-flutuante-aparecer-enter-active,
  .protecao-flutuante-aparecer-leave-active {
    transition-duration: 0.01ms;
  }
  .woot-widget-bubble.wellon-chatwoot-hover-expand,
  .woot-widget-bubble.wellon-chatwoot-hover-expand #woot-widget--expanded__text,
  .woot-widget-bubble.wellon-chatwoot-hover-expand--aberta {
    transition-duration: 0.01ms !important;
  }
}
</style>
